import translationsAccount from './localization/translations.json';
import translationsServus from './localization/translations-servustv.json';
import GlobalNav from '../components/profile/GlobalNav';
import ServusNav from '../components/profile/ServusNav';

const TENANT = process.env.REACT_APP_TENANT || 'account'; // or 'servustv'
const TENANT_CONFIG = {
  account: {
    enableLibrary: true,
    theme: 'defaultTheme',
    translations: translationsAccount,
    interestsOnProfile: true,
    logo: {
      alt: 'Red Bull Logo',
      src:
        'https://account.redbull.com/bundles/assets/img/redbull_com_logo.svg',
      width: '198px',
    },
    nav: GlobalNav,
    overrideAcceptTermsText: true,
    policyBaseURL: {
      design: 'https://policies-design.redbull.com/r/Red_Bull_Account',
      production: 'https://policies.redbull.com/r/Red_Bull_Account',
    },
    analytics: {
      brand: 'redbull',
      propertyName: 'rb-universal-account',
    },
  },
  servustv: {
    enableLibrary: false,
    theme: 'servusTheme',
    translations: translationsServus,
    interestsOnProfile: false,
    logo: {
      alt: 'ServusTV Logo',
      src:
        'https://account.redbull.com/bundles/assets/static/img/servus-black.svg',
      width: '90px',
    },
    nav: ServusNav,
    overrideAcceptTermsText: false,
    policyBaseURL: {
      design: 'https://policies-design.redbull.com/r/Servus_TV_Account_design',
      production:
        'https://policies.redbull.com/r/b540b0de-a92e-4225-b317-0b10e7acd238',
    },
    analytics: {
      brand: 'servus',
      propertyName: 'servustv-account',
    },
  },
};

/**
 * Return config based on current tenant
 */
const getTenantConfig = () => {
  return TENANT_CONFIG[TENANT];
};

/**
 * Return nav based on current tenant
 */
const getTenantNav = (country, language) => {
  const Component = getTenantConfig().nav;
  const nav = <Component country={country} language={language} />;
  return nav;
};

export { getTenantConfig, getTenantNav };
